const COMPANY_TYPE = {
  Manager: 1,
  Allocator: 2,
  ServiceProvider: 3,
  Iconnections: 4,
  Speaker: 5,
  Guest: 6,
  Media: 7,
  Other: 8,
  NFT: 9,
  StudentOrRetired: 10,
  People: 11,
};
export default COMPANY_TYPE;
